import React, { createRef, PureComponent } from "react";
import Draggable from "react-draggable";
import initWebcam from "./initPico";
import "./Webcam.css";
import shutter from "./shutter.m4a";

// import initCmlTracker from "./initClmtrackr";

const pause = async delayMs =>
  new Promise(resolve => setTimeout(resolve, delayMs));

const WIDTH = 640;
const HEIGHT = 480;

const calculateDefaultPosition = dimensions => {
  return {
    x: dimensions.width / 2 - WIDTH / 2,
    y: dimensions.height / 2 - HEIGHT / 2
  };
};

export default class Webcam extends PureComponent {
  canvas = createRef();
  state = {
    isFlashing: false
  };
  audio = new Audio(shutter);

  static getDerivedStateFromProps(props) {
    return {
      defaultPosition: calculateDefaultPosition(props.dimensions)
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.webcamEnabled && !prevProps.webcamEnabled) {
      this.startWebcam();
    }
    if (this.props.isSafewordShouted && !prevProps.isSafewordShouted) {
      this.stopWebcam();
    }
    if (this.props.takePicture && !prevProps.takePicture) {
      this.takePicture();
      this.stop();
    }
  }

  async startWebcam() {
    await this.bringToFront();
    this.forceUpdate();
    const canvasElement = this.canvas.current;
    this.stop = await initWebcam({
      canvasElement,
      update: this.updateCanvas
    });
    this.props.setAppState({ webcamHasBeenStarted: true });
  }

  stop = () => {};

  async stopWebcam() {
    this.stop();
    await pause(4000);
    this.setState({ hideCamera: true });
  }

  componentWillUnmount() {
    this.stop();
  }

  updateCanvas = (ctx, face) => {
    const [y, x, diameter] = face;
    ctx.fillStyle = "red";
    ctx.font = `${Math.round(diameter / 7)}px Arial`;
    const drawText = (text, x, y) => {
      const { width } = ctx.measureText(text);
      ctx.fillText(text, x, y, width * 0.4);
    };
    drawText("STARING EYES", x + -200, y + -90);
    drawText("NOSE LIKE A PIG", x + 40, y + 20);
    drawText("A MOUTH NOT WORTH FUCKING", x + -40, y + 120);
    drawText("DISGUSTING BODY", x, y + 220);
  };

  bringToFront = () => {
    return new Promise(resolve => {
      this.setState({ zIndex: this.props.getZIndex() }, resolve);
    });
  };

  takePicture = async () => {
    this.playShutterSound();
    setTimeout(() => {
      this.setState({ isFlashing: true });
      setTimeout(() => {
        this.setState({ isFlashing: false });
        if (this.canvas.current) {
          this.downloadCanvas(this.canvas.current);
          // this.uploadCanvas(this.canvas.current);
          this.setupCanvasUpload(this.canvas.current);
        }
      }, 1000);
    }, 500);
  };

  downloadCanvas(canvas) {
    const link = document.createElement("a");
    link.download = "princess-worship-club-souvenir.jpg";
    link.href = canvas.toDataURL("image/jpeg");
    link.click();
  }

  uploadCanvas(canvas) {
    canvas.toBlob(imageBlob => {
      const body = new FormData();
      body.append("form-name", "gallery");
      body.append("name", this.props.name);
      body.append("image", imageBlob);
      fetch(
        `https://www.princessworship.club/`,
        {
          method: "POST",
          body
        },
        "princess-worship-club.jpg"
      ).catch(e => {});
    }, "image/jpeg");
  }

  setupCanvasUpload(canvas) {
    sessionStorage.setItem(
      "wallOfShameProspect",
      JSON.stringify({
        name: this.props.name,
        image: canvas.toDataURL("image/jpeg"),
        created_at: new Date().toISOString()
      })
    );

    // window.uploadPictureToWallOfShame = () => {
    //   canvas.toBlob(imageBlob => {
    //     const body = new FormData();
    //     body.append("form-name", "gallery");
    //     body.append("name", this.props.name);
    //     body.append("image", imageBlob);
    //     fetch(
    //       `https://www.princessworship.club/`,
    //       {
    //         method: "POST",
    //         body
    //       },
    //       "princess-worship-club.jpg"
    //     ).catch(e => {});
    //   }, "image/jpeg");
    // };
  }

  playShutterSound = async () => {
    Promise.resolve(this.audio.play()).catch(e => {});
  };

  render() {
    const styles = {
      // visibility: this.props.webcamEnabled ? "visible" : "hidden",
      zIndex: this.state.zIndex
    };
    if (!this.props.webcamEnabled || this.state.hideCamera) {
      return null;
    }

    return (
      <div>
        {this.state.isFlashing && <div className="Flash" />}
        <div className="Webcam" style={styles}>
          <Draggable
            defaultPosition={this.state.defaultPosition}
            onStart={this.bringToFront}
          >
            <div>
              <div>
                <canvas width={WIDTH} height={HEIGHT} ref={this.canvas} />;
              </div>
            </div>
          </Draggable>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Webcam/index.js